import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ContactoComponent} from "./contacto.component";
import {AgmCoreModule} from "@agm/core";
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';

@NgModule({
  imports: [
    CommonModule, AgmCoreModule, AgmSnazzyInfoWindowModule
  ],
  declarations: [ContactoComponent],
  exports: [ContactoComponent]
})
export class ContactoModule { }



// WEBPACK FOOTER //
// ./src/app/layouts/contacto/contacto.module.ts